import { REVIEW_MAX_STARS } from '../constants';

export const getStars = (value = 0) => {
  if (value <= 0) {
    return [
      { iconId: 'star_full', count: 0 },
      { iconId: 'star_half', count: 0 },
      { iconId: 'star_empty', count: 5 },
    ];
  }

  if (value >= REVIEW_MAX_STARS) {
    return [
      { iconId: 'star_full', count: 5 },
      { iconId: 'star_half', count: 0 },
      { iconId: 'star_empty', count: 0 },
    ];
  }

  const full = Math.floor(value);
  const half = value - full > 0 ? 1 : 0;
  const empty = REVIEW_MAX_STARS - full - half;

  return [
    { iconId: 'star_full', count: full },
    { iconId: 'star_half', count: half },
    { iconId: 'star_empty', count: empty },
  ];
};
